import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

declare global {
    interface Window {
        Apex: any;
    }
}

pdfDefaultOptions.assetsFolder = 'assets';
pdfDefaultOptions.needsES5 = false;

platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
